module.exports = __webpack_public_path__ + "static/media/transpRollet3.abf35207.jpg";